import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { msg } from 'src/app/constants/msg';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  public showSuccess(text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      heightAuto: false,
      text: text,
      icon: 'success',
      customClass: {
        confirmButton: 'swal-confirm-btn',
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    });
  }

  public showError(text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      heightAuto: false,
      text: text,
      icon: 'error',
      customClass: {
        confirmButton: 'swal-confirm-btn',
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    });
  }

  public showInfo(title: string, message: string): Promise<SweetAlertResult> {
    return Swal.fire({
      confirmButtonColor: '#fbaf47',
      heightAuto: false,
      title: title,
      text: message,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn'
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    });
  }

  public showDiscardChanges(title?: string, message?: string): Promise<SweetAlertResult> {
    return Swal.fire({
      heightAuto: false,
      title: title ? title : msg.discardChanges.title,
      text: message ? message : msg.discardChanges.text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: msg.discardChanges.confirmButtonText,
      cancelButtonText: msg.discardChanges.cancelButtonText,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      }
    })
  }
}
